export default __webpack_public_path__ + "static/media/Netflix-hover.7270737a.svg";